module.exports = {
  langs: ["en", "de"],
  defaultLangKey: "en",
}
